import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { AbstractFormFieldComponent } from '../../abstract-form-field.component';
import { DatepickerFormField } from '../../form-field.model';

@Component({
  selector: 'iot-platform-ui-form-date-picker-field',
  imports: [
    FlexLayoutModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslatePipe,
    MatTooltipModule,
    FormsModule,
    NgClass,
    MatDatepickerModule,
    NgTemplateOutlet
  ],
  templateUrl: './form-date-picker-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../form-field/form-field.component.scss'
})
export class FormDatePickerFieldComponent extends AbstractFormFieldComponent<DatepickerFormField> {}
